import { Checkbox } from "components/Form/components/Checkbox/Checkbox";
import { CheckboxGroup } from "components/Form/components/Checkbox/CheckboxGroup";
import { FormComponentProps } from "components/Form/components/FormComponentProps";
import { Input } from "components/Form/components/Input/Input";
import { InputComponentProps } from "components/Form/components/InputComponentProps";
import { ValueLabelPair } from "containers/ExecutionFilter/interfaces";
import React from "react";

interface CheckboxGroupProps {
    identifier: string;
    input: InputComponentProps<string[]>;
    attributes?: { row?: boolean; disabled?: boolean };
    options: ValueLabelPair[];
    currentValue: string[];
    onChange: (value) => (event: React.ChangeEvent<HTMLInputElement>) => void;
}

interface NestedCheckboxGroupProps {
    mainLabel: string;
    onChangeAll: (e: React.ChangeEvent<HTMLInputElement>) => void;
    mainCheckboxValue?: boolean | null;
    identifier: CheckboxGroupProps["identifier"];
    input: CheckboxGroupProps["input"];
    options: ValueLabelPair[];
    onChange: CheckboxGroupProps["onChange"];
}

export const NestedCheckboxGroup = ({
    mainLabel,
    onChangeAll,
    mainCheckboxValue,
    identifier,
    input,
    options,
    onChange,
}: NestedCheckboxGroupProps) => (
    <Checkbox
        label={mainLabel}
        onChange={onChangeAll}
        value={mainCheckboxValue}
        className="checkbox-group__container"
    >
        <CheckboxGroupContainer
            identifier={identifier}
            input={input}
            options={options}
            currentValue={input.value}
            onChange={onChange}
        />
    </Checkbox>
);

export const CheckboxGroupContainer = ({
    identifier,
    input,
    attributes,
    options,
    currentValue,
    onChange,
}: CheckboxGroupProps) => {
    return (
        <CheckboxGroup {...input} {...attributes} aria-label={identifier}>
            {options.map((option) => (
                <Checkbox
                    key={option.value}
                    value={currentValue.includes(option.value)}
                    onChange={onChange(option.value)}
                    label={option.label}
                    size="small"
                />
            ))}
        </CheckboxGroup>
    );
};

export const CheckboxGroupFormComponent = ({
    input,
    meta,
    fieldProps,
    fieldAttr,
}: FormComponentProps) => {
    return (
        <Input fieldProps={fieldProps} fieldAttr={fieldAttr} input={input} meta={meta}>
            <CheckboxGroupContainer
                identifier={input.name}
                input={input}
                attributes={fieldAttr}
                options={fieldProps.options}
                currentValue={fieldProps.currentValue}
                onChange={fieldProps.onChange}
            />
        </Input>
    );
};
